import { render, staticRenderFns } from "./BlockBlogHeaderUser.vue?vue&type=template&id=401d2994&scoped=true&"
import script from "./BlockBlogHeaderUser.vue?vue&type=script&lang=js&"
export * from "./BlockBlogHeaderUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogHeaderUser.vue?vue&type=style&index=0&id=401d2994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d2994",
  null
  
)

export default component.exports